import axios from 'axios';
import {
    getDocDetailsResult,
    initNewWorkflowResult,
    SDKCheckStatus
} from '../types';
import { Applicant } from '../../onfido-sdk/types';

export const getDocDetailsUrl = `${process.env.REACT_APP_ONFIDO_SDK_ENDPOINT}/get-doc-details?applicantId={applicantId}&workflowRunId={workflowRunId}`;
export const initNewWorkflowUrl = `${process.env.REACT_APP_ONFIDO_SDK_ENDPOINT}/init-new-workflow?applicantId={applicantId}&workflowRunId={workflowRunId}`;

const parseResultStatus = (returnStatus: string): SDKCheckStatus => {
    return (
        {
            "Incomplete": "check-incomplete",
            "Documents Unavailable": "check-incomplete",
            "DATA_INTEGRITY_ISSUE": "check-incomplete",
            "Documents Available": "doc-verified",
            "UNSUPPORTED_DOCUMENT": "doc-not-supported",
            "IMAGE_INTEGRITY_ISSUE": "doc-image-poor-quality",
            "OTHER_ISSUE": "doc-details-failure"
        } as { [key: string]: SDKCheckStatus }
    )[returnStatus] || parseResultStatus("OTHER_ISSUE");
};

export const getDocDetails = async (
    applicant: Applicant
): Promise<SDKCheckStatus> => {
    const url = getDocDetailsUrl
        .replace("{applicantId}", `${applicant.applicantId}`)
        .replace("{workflowRunId}", `${applicant.workflowRunId}`);
    const headers = { Authorization: `Token ${applicant.sdkToken}` };

    return await axios.get(url, { headers: headers })
    .then(({status, data}: getDocDetailsResult) => {
        if (status === 200) {
            return parseResultStatus(data.reason || data.result);
        } else if (status === 202) {
            return "check-incomplete";
        } else {
            return "doc-details-failure";
        }
    }).catch(error => {
        console.error(error);
        return "doc-details-failure";
    });
};

export const initNewWorkflow = async (
    applicant: Applicant
): Promise<Applicant> => {
    const url = initNewWorkflowUrl
        .replace("{applicantId}", `${applicant.applicantId}`)
        .replace("{workflowRunId}", `${applicant.workflowRunId}`);
    const headers = { Authorization: `Token ${applicant.sdkToken}` };

    return await axios.post(url, {}, { headers: headers })
    .then(({status, data}: initNewWorkflowResult) => {
        if (status === 200) {
            applicant.sdkToken = data.sdk_token;
            applicant.workflowRunId = data.workflow_run_id;
        } else {
            console.error('init new workflow error');
            applicant.workflowRunId = "";
        }
        return applicant;
    }).catch(error => {
        console.error(error);
        applicant.workflowRunId = "";
        return applicant;
    });
};
